import React from 'react';
import Alert from 'common/Alert';
import Logo from 'common/Logo';
import SharePalette from 'social/SharePalette';
import playable from 'common/playable';
import { getMinutesUntilStart, dateFormat } from 'lib/format';
import { AlertPlacement } from 'enums';

const IS_BLACKED_OUT_MESSAGE = 'Not available in your area';
const DISPLAY_ALERT_UNTIL = 30; // minutes

class ScheduleEventCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayAlert: false
        };
        this.toggleAlert = this.toggleAlert.bind(this);
    }

    toggleAlert(event) {
        event.preventDefault();
        this.setState({ displayAlert: !this.state.displayAlert });
    }

    render() {
        const { blackoutMapHandler, content, clickHandler, userAuthenticatedForContent, userLocation } = this.props;
        const { blackouts = [], id, name, rawDate, source, status, subtitle } = content;
        const minutesUntilStart = getMinutesUntilStart(content || {});

        let footerText = subtitle;
        let subtitleClickHandler = null;
        const displayTime = userLocation && userLocation.timeZone ?
            dateFormat.convertDateTime(rawDate, { timeZone: userLocation.timeZone }) :
            dateFormat.dateFormat(rawDate, 'dateTime2');
        if (blackouts.length > 0) {
            const dmaBlackout = blackouts.filter((blackout) => (blackout.type === 'dma')).shift();
            const dma = (userLocation && userLocation.dma) || '';
            const userIsBlackedOut = dmaBlackout && dmaBlackout.detail.indexOf(dma.toString()) >= 0;
            if (userIsBlackedOut) {
                footerText = IS_BLACKED_OUT_MESSAGE;
                subtitleClickHandler = blackoutMapHandler;
            }
        }
        const addToCalendarEl = null;
        let articleClasses = 'contentItem contentItem--module';
        let handleClick = clickHandler;
        if (status === 'upcoming') {
            if (minutesUntilStart >= DISPLAY_ALERT_UNTIL) {
                handleClick = this.toggleAlert;
            }
            // addToCalendarEl = <AddToCalendar content={content} placement={AddToCalendarPlacement.EVENT_CARD} />;
            articleClasses = `${articleClasses} contentItem--hasAlert`;
        }

        const keyClass = !userAuthenticatedForContent ? ' icon-key-solid-after' : '';
        return (
            <article className={articleClasses} data-id={id}>
                <Alert
                    content={content}
                    display={this.state.displayAlert}
                    displayTime={displayTime}
                    onClose={this.toggleAlert}
                    placement={AlertPlacement.EVENT_CARD}
                />
                <header className="contentItem__header contentItem__header--module">
                    <div href="#" className="contentItem__header__wrapper">
                        <Logo iconHref={content.iconHref} className={'contentItem__logo'} />
                    </div>
                </header>
                <a onClick={handleClick}>
                    <section className="contentItem__content contentItem__content--module">
                        <div className="metaData">
                            <span className="schedule-time">{displayTime}</span>
                            <span className={`icon-font-after${keyClass}`}>{source}</span>
                        </div>
                        <h1 className="contentItem__title">{name}</h1>
                    </section>
                </a>
                <footer className="contentItem__footer contentItem__footer--module">
                    <div onClick={subtitleClickHandler} className="metaData">
                        <span>{footerText}</span>
                    </div>
                    {addToCalendarEl}
                    <SharePalette content={content} />
                </footer>
            </article>
        );
    }
}

ScheduleEventCard.propTypes = {
    blackoutMapHandler: React.PropTypes.func,
    content: React.PropTypes.object,
    clickHandler: React.PropTypes.func,
    userAuthenticatedForContent: React.PropTypes.bool,
    userLocation: React.PropTypes.object
};

export default playable(ScheduleEventCard);
export { ScheduleEventCard as BaseScheduleEventCard };



// WEBPACK FOOTER //
// ./app/scheduleModule/ScheduleEventCard.js